module.exports = "data:application/x-tgif;base64,IyBCbGVuZGVyIHYyLjc5IChzdWIgMCkgT0JKIEZpbGU6ICd0YWJsZXQtMS5ibGVuZCcKIyB3d3cuYmxlbmRlci5vcmcKdiAtMC43NTAwMDAgMC4wMDAwMDAgMS4wMDAwMDAKdiAwLjc1MDAwMCAwLjAwMDAwMCAxLjAwMDAwMAp2IC0wLjc1MDAwMCAwLjAwMDAwMCAtMS4wMDAwMDAKdiAwLjc1MDAwMCAwLjAwMDAwMCAtMS4wMDAwMDAKdnQgMC45OTYwOTQgMC4wMDAwMDAKdnQgMC45OTYwOTQgMC45OTYwOTQKdnQgMC4wMDAwMDAgMC45OTYwOTQKdnQgMC4wMDAwMDAgMC4wMDAwMDAKdm4gMC4wMDAwIDEuMDAwMCAwLjAwMDAKcyBvZmYKZiAxLzEvMSAyLzIvMSA0LzMvMSAzLzQvMQo="


//////////////////
// WEBPACK FOOTER
// ./src/components/app-experience/Experience/models/tablet-screen.obj
// module id = Fb+K
// module chunks = 1